/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React, { useState, useEffect } from "react"
import '../../../styles/tailwind-global.css';
import HeaderTinaba from "../../../views/header-tinaba";
import SEO from "../../../components/seo";
import HeroImage from "../common/views/hero-image";
import DescrizionePacchetto from "../common/views/descrizione-pacchetto";
import VantaggiPacchetto from "../common/views/vantaggi-pacchetto";
import Footer from "../../../views/footer";
import ModalTuttiBrand from "../../../views/modal-tutti-brand";
import * as s from "./index.module.css"
import { pushDataLayerToWindow } from '../../../utils/gtm-helpers'
import premiumCrowdfunding from '../../../images/premium/premium_crowdfunding.svg';
import premiumExtraBonus from '../../../images/premium/premium_extra_bonus.svg';
import premiumExtraCashback from '../../../images/premium/premium_extra_cashback.svg';
import premiumPrelieviGratuiti from '../../../images/premium/premium_prelievi_gratuiti.svg';
import premiumScontiQuotidiani from '../../../images/premium/premium_sconti_quotidiani.svg';
import premiumTinabaPremiumConContoHit from '../../../images/premium/premium_tinaba_premum_con_conto_hit.svg';
import PremiumComeFunziona from "./views/premium-come-funziona";
import CookieConsentBox from "../../../components/cookie-consent-box";
import ModalPagamento from "./views/modal-pagamento";
import Button from "../../../components/button";
import PremiumCosaPuoiFare from "./views/premium-cosa-puoi-fare";
import PremiumCosti from "./views/premium-costi";
import PrevenditaChiusa from "../common/views/prevendita-chiusa";
import { isProjectStatusUnavailable } from "../../../utils/validate-helpers";

const vantaggiBoxes = [
    { image: premiumScontiQuotidiani, titolo: 'Sconti quotidiani', testo: 'Un mondo di sconti per la tua spesa quotidiana: alimentari, carburanti, abbigliamento e tantissime altre categorie per aiutarti a risparmiare ogni giorno​' },
    { image: premiumPrelieviGratuiti, titolo: 'Prelievi gratuiti', testo: 'Usa la tua carta per tutti i tuoi pagamenti e, se hai bisogno di contanti, preleva da un qualsiasi ATM in UE, è gratis!​' },
    { image: premiumExtraBonus, titolo: 'Extra Bonus', testo: 'Invita i tuoi amici a registrarsi a Tinaba, per te ci sono 5€ extra di bonus!​' },
    { image: premiumExtraCashback, titolo: 'Extra Cashback', testo: 'Usa la tua app per i tuoi bollettini, il bollo auto e PagoPa per avere un cashback di 2€ sui primi 5 pagamenti' },
    { image: premiumTinabaPremiumConContoHit, titolo: 'Combina Tinaba Premium e Conto Hit', testo: 'Scegli Tinaba Premium e se tuo/a figlio/a segue una delle star selezionate da Tinaba potrà avere il 50% di sconto sulla membership del suo talent preferito.' },
    { image: premiumCrowdfunding, titolo: 'Crowdfunding Unlimited', testo: 'Il tuo progetto di crowdfunding non ha limiti e puoi raccogliere donazioni tramite Tinaba, Carte di pagamento e Paypal' },
]



const Base = ({ pageContext: { project } }) => {

    const [isModalTuttiBrandVisible, setIsModalTuttiBrandVisible] = useState(false);
    const [isModalPagamentoVisible, setIsModalPagamentoVisible] = useState(false);
    const [isBaseDivLocked, setIsBaseDivLocked] = useState(false);

    useEffect(() => {
        setIsBaseDivLocked(isModalPagamentoVisible || isModalTuttiBrandVisible);
    }, [isModalPagamentoVisible, isModalTuttiBrandVisible])

    useEffect(() => {
        // Evento GTM
        pushDataLayerToWindow({
            'pageCategory': 'Landing Page',
            'pageName': 'Landing Page Premium',
            'pageSubCategory': 'Premium',
        });
    }, []);

    return (
        <div style={{ height: isBaseDivLocked ? '100vh' : 'auto', overflowY: isBaseDivLocked ? 'hidden' : 'auto' }}>
            <SEO meta={project.__metaTags} />

            <HeaderTinaba project={project} />

            <HeroImage project={project} />

            {isProjectStatusUnavailable(project) && <PrevenditaChiusa project={project} />}

            <DescrizionePacchetto project={project} descriptionTitleStyle={{ fontSize: '34px', lineHeight: '40px', textAlign: 'center' }} />

            <VantaggiPacchetto project={project} boxes={vantaggiBoxes} title="Tutti i vantaggi di Tinaba Premium" />

            <div className="container flex flex-col align-center items-center justify-center" style={{ marginTop: '70px' }}>
                <Button style={{ maxWidth: '335px' }} className={`btn-acquista-tinaba-premium ${isProjectStatusUnavailable(project) ? 'opacity-50 cursor-not-allowed' : 'opacity-100 cursor-pointer'}`} disabled={isProjectStatusUnavailable(project)}
                    onClick={() => {
                        setIsModalPagamentoVisible(true);
                    }}>
                    Acquista Tinaba Premium ora
                </Button>
                {isProjectStatusUnavailable(project) && (<div className="font-rg text-9 text-black" style={{ marginTop: '8px' }}>La prevendita è chiusa</div>)}

            </div>

            <PremiumCosaPuoiFare project={project} onButtonClick={() => {
                setIsModalPagamentoVisible(true);
                // window.location.href = `${process.env.PAGES_BASE_URL}/${project.alias}/preorder`;
            }} />

            <PremiumComeFunziona project={project} />

            <PremiumCosti project={project} />

            <div className={s.footer}>
                <Footer project={project} />
            </div>

            <ModalTuttiBrand project={project} visible={isModalTuttiBrandVisible} requestClose={() => { setIsModalTuttiBrandVisible(false) }} />

            <CookieConsentBox />

            <ModalPagamento project={project} visible={isModalPagamentoVisible} requestClose={() => { setIsModalPagamentoVisible(false) }} goNext={() => {
                setIsModalPagamentoVisible(false);
                setTimeout(() => {
                    // submitForm();
                }, 500);
            }} />
        </div>
    )
}


export default Base
